<template>
	<div>
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="page" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="page-header">
				<div class="page-header-container">
					<div class="page-header-inner">
						<div class="fx">
							<div class="page-header-left">
								<div class="page-header-title">
									<h1>X96Q</h1>
								</div>
								<div class="content custom">
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.x96q.f')}}</div>
									</div>
									<div class="check-item">
										<div class="img-wrap">
											<img src="../../static/img/check.png" alt="">
										</div>
										<div class="text">{{ $t('feature.x96q.s')}}</div>
									</div>
								</div>
								<div class="nav-link">
									<div class="buy-wrap" @click="onBuy">
										{{ $t('buy')}}
									</div>
									<div class="nav-conn">
										<a href="javascript: void (0)" class="link" @click="onTele">
											<span class="iconfont icon-a-telegram"></span>
										</a>
										<a href="javascript: void (0)" class="link pl8" @click="onWhatapp">
											<span class="iconfont icon-whatsapp"></span>
										</a>
									</div>
								</div>
							</div>
							<div class="page-header-right">
								<LazyImage className="viewport" imagePath="/res/img/swiper_2.png"></LazyImage>
							</div>
						</div>
					</div>
				</div>
				<div class="preview-wrap">
					<div class="preview-inner">
						<div class="fx">
							<div class="product-list-wrap">
								<div class="product-item" v-for="(img, index) in imgList" :key="index"
									@click="showPicture(img)">
									<img :src="`/res/img/${img.path}`" alt="" />
								</div>
							</div>
							<!-- <div class="preview-btn">
												<div class="prev link">
									<span class="iconfont icon-zuojiantou"></span>
								</div>
								<div class="next link">
									<span class="iconfont icon-youjiantou"></span>
								</div> 
							</div>-->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="equipment-parameters" id="equipment-parameters">
			<div class="equipment-parameters-wrap">
				<div class="equipment-parameters-inner">
					<h2>{{ $t('feature.specification') }} </h2>
					<h4>{{ $t('feature.product') }} </h4>
					<div class="equipment-content-main">
						<div class="min-equipment">
							<ul class="equipment-ul-list">
								<li v-for="(title, i) in list" :key="i" :class="curIndex == i ? 'active' : ''">
									<a href="javascript: void (0)" @click="checkData(i)">{{ title.category }}</a>
								</li>
							</ul>
							<div class="equipment-table-wrap">
								<table>
									<tbody v-for="(data, idx) in midData" :key="idx">
										<tr class="key">
											<div>{{ data.name }}</div>
										</tr>
										<tr class="val">
											<div>{{ data.value }}</div>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<p class="equipment-content" v-for="(product, index) in list" :key="index">
						<table>
							<thead>
								<tr>
									<th>{{ product.category }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(s, idx) in product.specs" :key="idx">
									<td class="parameters-name">{{ s.name }}</td>
									<td class="parameters-detail">{{ s.value }}</td>
								</tr>
							</tbody>
						</table>
						</p>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
		<div class="dialog" v-show="isShow">
			<div class="mask"></div>
			<div class="dialog-content">
				<div class="dialog-inner" ref="inner" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<img :src="`/res/img/${path}`" alt="">
				</div>
				<div class="close" @click="closePicture" :class="isShow ? 'scale-in-center' : 'scale-out-center'">
					<span class="iconfont icon-guanbi"></span>
				</div>
				<div class="banner-swiper">
					<div class="prev" @click="onPrev">
						<span class="iconfont icon-zuojiantou"></span>
					</div>
					<div class="next" @click="onNext">
						<span class="iconfont icon-youjiantou"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'X96Q',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				isShow: false,
				path: 'x96q/x96q1_2.png', // 使用v-show 需指定默认值
				imgList: [{
						path: 'x96q/x96q1.png',
						dPath: 'x96q/x96q1_2.png'
					},
					{
						path: 'x96q/x96q2.png',
						dPath: 'x96q/x96q2_2.png'
					},
					{
						path: 'x96q/x96q3.png',
						dPath: 'x96q/x96q3_2.png'
					},
					{
						path: 'x96q/x96q4.png',
						dPath: 'x96q/x96q4_2.png'
					},
					{
						path: 'x96q/x96q5.png',
						dPath: 'x96q/x96q5_2.png'
					}
				],
				list: [{
						category: "Basic",
						specs: [{
								name: "CPU",
								value: "Allwinner H313 Quad Core ARM Cortex A53"
							},
							{
								name: "GPU",
								value: "G31 OPenGL3.2"
							},
							{
								name: "Memory",
								value: "R3：1GB (Option: 2GB)"
							},
							{
								name: "Flash",
								value: "eMMC：8GB  (Option:16GB )"
							},
							{
								name: "Moudle",
								value: "Plastic : Black  Color"
							},
							{
								name: "WiFi",
								value: "IEEE 802.11 b/g/n"
							},
							{
								name: "Power",
								value: "DC 5V/2A"
							}
						]
					},
					{
						category: "Packing",
						specs: [{
								name: "Product Dimension",
								value: "88.4*88.4*18.6(mm)"
							},
							{
								name: "Qty per unit packing",
								value: "1pcs"
							},
							{
								name: "Unit packing (G.W.)",
								value: "0.35Kg"
							},
							{
								name: "Unit packing: (LxWxH)",
								value: "170*115*55mm"
							}
						]
					},
					{
						category: "Software",
						specs: [{
								name: "OS",
								value: "Android 10.0"
							},
							{
								name: "video",
								value: "*.mkv,*.wmv,*.mpg, *.mpeg, *.dat, *.avi, *.mov, *.iso, *.mp4, *.rm and *.jpg file formats"
							},
							{
								name: "Audio",
								value: "MP3, AAC, WMA, RM, FLAC, Ogg and programmable with 7.1/5.1 down-mixing"
							},
							{
								name: "Image",
								value: "HD JPEG、BMP、GIF、PNG、TIF"
							},
							{
								name: "Language",
								value: "English French German Spanish Italian etc multilateral languages"
							}
						]
					},
					{
						category: "IO",
						specs: [{
								name: "1*HDMI",
								value: "4K*2K UHD Output, HDMI 2.0A"
							},
							{
								name: "1*AV OUT",
								value: "480i/576i standard definition output"
							},
							{
								name: "2*USB",
								value: "1* USB Host Port ,1*USB Device"
							},
							{
								name: "1*IR Reciver",
								value: "Remote Reciver Connect"
							},
							{
								name: "1*RJ45",
								value: "Ethernet Interface"
							},
							{
								name: "1*TF CARD",
								value: "4GB/8GB/16GB/32GB/64GB"
							}
						]
					}
				],
				curIndex: 0,
				url: 'https://auroratvos.com/product/2131/'
			};
		},
		computed: {
			midData() {
				return this.list[this.curIndex].specs || []
			}
		},
		methods: {
			showPicture(img) {
				this.path = img.dPath
				this.isShow = true
				this.$refs.inner.classList.remove('scale-out-center')
			},
			closePicture() {
			this.$refs.inner.classList.add('scale-out-center')
			this.isShow = false
			},
			checkData(idx) {
				this.curIndex = idx
			},
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			onBuy() {
				window.open(this.url)
			},
			onTele () {
				window.open('https://t.me/AuroraMCPlayer')
			},
			onWhatapp () {
				window.open('https://wa.me/79315988108')
			},
			onPrev () {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if(index > 0) {
					this.path = this.imgList[--index].dPath
				}
			},
			onNext () {
				let index = this.imgList.findIndex(item => item.dPath === this.path)
				if(index < this.imgList.length - 1) {
					this.path = this.imgList[++index].dPath
				}
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less'>

</style>